export default {
  'SET_OVERLAY'(state, data) {
    state.loadingOverlay = data;
  },
  'SHOW_OVERLAY'(state) {
    state.loadingOverlay = true;
  },
  'HIDE_OVERLAY'(state) {
    state.loadingOverlay = false;
  },
  'SET_MENU_VISIBLE'(state, data) {
    state.menuVisible = data;
  },
  'SHOW_MENU'(state) {
    state.menuVisible = true;
  },
  'HIDE_MENU'(state) {
    state.menuVisible = false;
  },
  'TOGGLE_MENU'(state) {
    state.menuVisible = !state.menuVisible;
  },
  'SET_AUTOMATIONS_ADVANCED_VIEW'(state, value) {
    state.automationsAdvancedView = value;
  },
  'SET_AUTOMATIONS_ADVANCED_VIEW_CHANGED'(state) {
    state.automationsAdvancedViewChanged = true;
  },
  'SET_IS_DARK'(state) {
    state.isDark = true;
  },
  'SET_WINDOW_SIZES'(state, data) {
    state.windowSizes = data;
  },
  'SET_CAMERA_SMALL_VIEW_SNAPSHOT_INTERVAL'(state, data) {
    state.cameraSmallViewSnapshotInterval = data;
  },
  'SET_CAMERA_VIEW_SNAPSHOT_INTERVAL'(state, data) {
    state.cameraViewSnapshotInterval = data;
  },
  'SET_INITIALIZING'(state, flag) {
    state.initalizing = flag;
    state.loadingOverlay = flag;
  },
  'SET_FEEDBACK'(state, data) {
    state.feedback = data;
  },
  'RESET_FEEDBACK'(state) {
    state.feedback = null;
  },
  'SET_BACKEND_ERROR'(state, code) {
    state.backendError = code;
  },
  'RESET_BACKEND_ERROR'(state) {
    state.backendError = 0;
  },
  'SET_GOOGLE_MAPS_API_KEY'(state, data) {
    state.googleMapsApiKey = data;
  },
  'SET_GOOGLE_MAPS_LIB_LOADED'(state, data = true) {
    state.googleMapsLibLoaded = data;
  },
  'SET_APP_VERSION'(state, data) {
    state.versions.app = data;
  },
  'SET_CLIENT_FINGERPRINT'(state, data) {
    state.clientFingerprint = data;
  },
  'SET_USAGE_ID'(state, data) {
    state.usageId = data;
  },
  'SET_GEOLOCATION_SUPPORTED'(state, data) {
    state.geolocationSupported = data;
  },
  'SET_GEOLOCATION'(state, data) {
    state.geolocation = data;
  },
  'SET_IS_MOBILE_USER_AGENT'(state, data) {
    state.isMobileUserAgent = data;
  },
  'SET_ENGINE_VERSION'(state, data) {
    state.versions.engine = data;
  },
  'SET_SYSTEM_INFO'(state, data) {
    state.system = data;
  },
  'SET_UI_VERSION'(state, data) {
    state.versions.ui = data;
  }
};
